import { render, staticRenderFns } from "./view.vue?vue&type=template&id=d9253862&scoped=true"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9253862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9253862')) {
      api.createRecord('d9253862', component.options)
    } else {
      api.reload('d9253862', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=d9253862&scoped=true", function () {
      api.rerender('d9253862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/lock/view.vue"
export default component.exports